import { render, staticRenderFns } from "./SubUnitNewButton.vue?vue&type=template&id=14679966&scoped=true&"
import script from "./SubUnitNewButton.vue?vue&type=script&lang=ts&"
export * from "./SubUnitNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubUnitNewButton.vue?vue&type=style&index=0&id=14679966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14679966",
  null
  
)

export default component.exports